import { useState, useEffect } from "react";
import SystemStatus from "./components/SystemStatus";
import SignalsPanel from "./components/SignalsPanel";
import PositionsPanel from "./components/PositionsPanel";
import JournalPanel from "./components/JournalPanel";
import ApprovalQueue from "./components/ApprovalQueue";
import LogPanel from "./components/LogPanel";
import axios from "axios";

const API = "https://bot.intellinu.com";
const API_KEY = "648e174af25fdd3aa923f9357c499a7f46e81d0138edfb8206263b097f4ccbea";
axios.defaults.headers.common["X-Dashboard-Key"] = API_KEY;

export default function App() {
  const [status, setStatus] = useState(null);
  const [positions, setPositions] = useState([]);
  const [journal, setJournal] = useState([]);
  const [summary, setSummary] = useState(null);
  const [queue, setQueue] = useState([]);

  const fetchAll = async () => {
    try {
      const [s, p, j, sum, q] = await Promise.all([
        axios.get(`${API}/`),
        axios.get(`${API}/positions`),
        axios.get(`${API}/journal`),
        axios.get(`${API}/journal/summary`),
        axios.get(`${API}/queue`)
      ]);
      setStatus(s.data);
      setPositions(p.data);
      setJournal(j.data);
      setSummary(sum.data);
      setQueue(q.data.pending);
    } catch (err) {
      console.error("API error:", err);
    }
  };

  useEffect(() => {
    fetchAll();
    const interval = setInterval(fetchAll, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={styles.app}>
      <header style={styles.header}>
        <h1 style={styles.title}>Trading Bot Dashboard</h1>
        <span style={{
          ...styles.modeBadge,
          background: status?.kill_switch ? "#e24b4a" : "#1D9E75"
        }}>
          {status?.kill_switch ? "KILL SWITCH ACTIVE" : `MODE: ${status?.mode?.toUpperCase()}`}
        </span>
      </header>

      <div style={styles.grid}>
        <SystemStatus status={status} API={API} onRefresh={fetchAll} />
        <ApprovalQueue queue={queue} API={API} onRefresh={fetchAll} />
        <PositionsPanel positions={positions} API={API} onRefresh={fetchAll} />
        <SignalsPanel summary={summary} journal={journal} />
        <JournalPanel journal={journal} />
        <LogPanel API={API} />
      </div>
    </div>
  );
}

const styles = {
  app: {
    minHeight: "100vh",
    background: "#0f0f0f",
    color: "#e0e0e0",
    fontFamily: "system-ui, sans-serif",
    padding: "0"
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 24px",
    background: "#1a1a1a",
    borderBottom: "1px solid #2a2a2a"
  },
  title: {
    margin: 0,
    fontSize: "20px",
    fontWeight: "600",
    color: "#ffffff"
  },
  modeBadge: {
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "700",
    color: "#ffffff",
    letterSpacing: "0.5px"
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))",
    gap: "16px",
    padding: "16px"
  }
};